import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useSoldGoodsCustomersList } from '@shared/api/lib/sold-goods/sold-goods';
import { ActivityCustomer } from '@shared/api/types';

export const useGetCustomersList = () => {
  return useSoldGoodsCustomersList<ActivityCustomer[]>({
    request: useAxiosConfig(),
  });
};
